import { LinkType } from './LinkType'

export interface IFormContact {
  title: string
  value: string
  valueLabel: string
  type: LinkType
}

export interface IFormContactBlock {
  readonly title: string
  readonly list: ReadonlyArray<IFormContact>
}

export const emptyFormContactBlock = (): IFormContactBlock => {
  return {
    title: '',
    list: [],
  }
}
